export default __webpack_public_path__ + "static/media/doctorcouple.ae59e407.jpg";